import Label, { Label as NotPureLabel } from './Label';
import * as Types from './Label.d';
import { StyledLabel, StyledErrorMsg, StyledLabelContainer } from './Label.styled';

export { NotPureLabel as Label, StyledLabel, StyledErrorMsg, StyledLabelContainer };
export type LabelProps = Types.LabelProps;
export type LabelColorVariant = Types.LabelColorVariant;
export default Label;
